import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({

    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/exam',
            name: 'exam',
            component: () => import('../components/exam/Exam.vue')
        },
        {
            path: '/examChoice',
            name: 'examChoice',
            component: () => import('../components/ExamChoice.vue')
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('../components/Login.vue')
        },
        {
            path: '/examOver',
            name: 'examOver',
            component: () => import('../components/exam/ExamOver.vue')
        },

    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js